import { Box, IconButton, Typography } from '@mui/material'
import { FC, useCallback } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

interface BlockTitleProps {
  back?: boolean
  backUrl?: string
  label: string
}

export const BlockTitle: FC<BlockTitleProps> = ({
  back = false,
  backUrl,
  label
}) => {
  const navigate = useNavigate()

  const goBack = useCallback(() => {
    if (backUrl) {
      navigate(backUrl)
    } else {
      navigate(-1)
    }
  }, [navigate])
  return (
    <Box display="flex" alignItems="center" gap={2}>
      {(back || backUrl) && (
        <IconButton onClick={goBack}>
          <ArrowBackIcon />
        </IconButton>
      )}
      <Typography variant="h5" fontWeight="bold" color="black">
        {label}
      </Typography>
    </Box>
  )
}
